/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { ReleaseTypeEnum } from './releaseTypeEnum';


export interface UpdateReleaseCapabilitySpec { 
    /**
     * Mapping of the capability name to its value
     */
    capabilities: { [key: string]: string; };
    operation: UpdateReleaseCapabilitySpec.OperationEnum;
    release_type: ReleaseTypeEnum;
    service_type: ServiceTypeEnum;
    cloud_provider?: CloudProviderEnum;
    /**
     * Version String for a release
     */
    version: string;
}
export namespace UpdateReleaseCapabilitySpec {
    export type OperationEnum = 'ADD' | 'UPDATE' | 'REMOVE';
    export const OperationEnum = {
        ADD: 'ADD' as OperationEnum,
        UPDATE: 'UPDATE' as OperationEnum,
        REMOVE: 'REMOVE' as OperationEnum
    };
}


